import CityPageTemplate from "../city-template/CityPageTemplate";
import { spearfishConfig } from "./data";

export default function SpearfishPage() {
  return <CityPageTemplate config={spearfishConfig} />;
}